// extracted by mini-css-extract-plugin
export default {"textBox":"upload_textBox__iPzUw"};